// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.trustwallet.app",
    name: "Trust Wallet",
    homepage: "https://trustwallet.com/",
    image_id: "7677b54f-3486-46e2-4e37-bf8747814f00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/apple-store/id1288339409",
        android: "https://play.google.com/store/apps/details?id=com.wallet.crypto.trustapp",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "com.trustwallet.app",
    mobile: {
        native: "trust://",
        universal: "https://link.trustwallet.com",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map